import apiClient from '../middleware/apiClient';
import { OT_PAYMENT_TRANSACTIONS } from '../helpers/apis';
import { COTTON_OT_PAYMENT_TRANSACTIONS } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_OT_PAYMENT_TRANSACTIONS = 'GET_OT_PAYMENT_TRANSACTIONS';
export const GET_OT_PAYMENT_TRANSACTIONS_SUCCESS = 'GET_OT_PAYMENT_TRANSACTIONS_SUCCESS';
export const GET_OT_PAYMENT_TRANSACTIONS_FAILURE = 'GET_OT_PAYMENT_TRANSACTIONS_FAILURE';


function dispatchGetOtPaymentTransactions(accountId, state, isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_OT_PAYMENT_TRANSACTIONS : OT_PAYMENT_TRANSACTIONS;
  return {
    type: GET_OT_PAYMENT_TRANSACTIONS,
    payload: apiClient.fetch(endpoint(accountId, state)),
  };
}

function dispatchGetOtPaymentTransactionsSuccess(paymentDetails) {
  return {
    type: GET_OT_PAYMENT_TRANSACTIONS_SUCCESS,
    payload: paymentDetails,
  };
}

function dispatchGetOtPaymentTransactionsError(error) {
  return {
    type: GET_OT_PAYMENT_TRANSACTIONS_FAILURE,
    payload: error,
  };
}

export const getOtPaymentTransactions = (accountId, state) => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(
      dispatchGetOtPaymentTransactions(accountId, state, isCottonSession),
    ).payload;
    return dispatch(dispatchGetOtPaymentTransactionsSuccess(response));
  } catch (error) {
    dispatch(dispatchGetOtPaymentTransactionsError(error));
    throw error;
  }
};
